import React from "react";
import Tooltip from "@common/Tooltip";

const TrailAssignmentProgressGraph = props => {
    const {results, onClick} = props;

    function handleResultClick(result) {
        if (onClick && typeof onClick === "function") {
            onClick(result);
        }
    }

    const resultsHeight = 48;
    const resultsWidth = 400;
    const resultsSpace = 4;
    const lineStart = 24;

    const resultsLength = Math.min(results.filter(result => result.complete).length, results.length);
    // const resultWidth = (resultsWidth - lineStart - (resultsSpace * (resultsLength + 1))) / resultsLength;
    const resultWidth = 16;

    let xPos = lineStart + resultsSpace;
    return (
        <div>
            <svg className="resultListAllResultGuide" height={resultsHeight} width={lineStart}>
                {results.map((result, i) => {
                    const resultPercentage = (result.score) ? result.score/100 : 0;
                    const resultHeight = result.stepHasResult && !result.skipStep ? resultsHeight * resultPercentage : resultsHeight;
                    let resultSvgJsx;

                    if (result.stepActivities && result.stepActivities.length > 0) {
                        const saResultSpace = 1;
                        const saResultWidth = result.stepActivities.length > 1 ? resultWidth / 1.6 : resultWidth;
                        const saResultBackgroundWidth = (saResultWidth + saResultSpace) * result.stepActivities.length - saResultSpace;
                        let rects = [];

                        rects.push(
                            <rect key={`${i}-sa-bg`} className="pw-rl-background" x={xPos} y={0} height={resultsHeight} width={saResultBackgroundWidth}/>
                        )
                        result.stepActivities.map((stepActivity, j) => {
                            const scoreMap = {
                                SELF_MARKED: stepActivity.answeredPercent,
                                AUTO_MARKED: stepActivity.score,
                                MARKED: stepActivity.score
                            };
                            const score = scoreMap[stepActivity.markState] ?? 0;
                            const saResultHeight = resultsHeight * (score / 100);
                            rects.push(
                                <rect
                                    key={`${i}-sa${j}`}
                                    className={!result.stepHasResult ? "pw-rl-noResult" : "pw-rl-correct"}
                                    x={xPos}
                                    y={resultsHeight - saResultHeight}
                                    height={saResultHeight}
                                    width={saResultWidth}
                                />
                            );
                            xPos += (saResultWidth + saResultSpace);
                        });
                        resultSvgJsx = (
                            <InteractiveResultGroup key={i} result={result} onClick={handleResultClick}>
                                {rects}
                            </InteractiveResultGroup>
                        )
                        xPos += resultsSpace - saResultSpace;
                    } else {
                        resultSvgJsx = (
                            <InteractiveResultGroup key={i} result={result} onClick={handleResultClick}>
                                <rect className="pw-rl-background" x={xPos} y={0} height={resultsHeight}  width={resultWidth}/>
                                <rect
                                    className={result.skipStep ? "pw-rl-skipped" : (!result.stepHasResult ? "pw-rl-noResult" : "pw-rl-correct")}
                                    x={xPos}
                                    y={resultsHeight - resultHeight}
                                    height={resultHeight}
                                    width={resultWidth}
                                />
                            </InteractiveResultGroup>
                        );
                        xPos += (resultWidth + resultsSpace);
                    }
                    return resultSvgJsx;
                })}
                <g style={{ignorePointerEvents: true, pointerEvents: "none"}}>
                    <text>
                        <tspan x={20} y={0} dy="0.4em" textAnchor="end">100%</tspan>
                        <tspan x={20} y={resultsHeight / 2} dy="0.4em" textAnchor="end">50%</tspan>
                        <tspan x={20} y={resultsHeight} dy="0.4em" textAnchor="end">0%</tspan>
                    </text>
                    <line x1={lineStart} y1={0} x2={xPos} y2={0}/>
                    <line x1={lineStart} y1={resultsHeight / 2} x2={xPos} y2={resultsHeight / 2}/>
                    <line x1={lineStart} y1={resultsHeight} x2={xPos} y2={resultsHeight}/>
                </g>
            </svg>
        </div>
    )
}

const InteractiveResultGroup = props => {
    const {result, onClick, children, ...other} = props;

    return (
        <Tooltip role={"none"} aria-label={null} title={result.pathwayActivityName} placement={"top"} enterNextDelay={0} disableInteractive>
            <g
                tabIndex={-1}
                // className={"resultListAllResult" + (result.skipStep && result.skipReason === "USER" ? " hover-user-skipped" : " hover-user-complete")}
                style={{cursor: "pointer"}}
                role="button"
                aria-label={`Result: ${result.pathwayActivityName}, Score ${result.score ?? 0}%`}
                onClick={() => {
                    if (onClick && typeof onClick === "function") onClick(result);
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        if (onClick && typeof onClick === "function") onClick(result);
                    }
                }}
                {...other}
            >
                {children}
            </g>
        </Tooltip>
    )
}

export default TrailAssignmentProgressGraph;